import React from 'react';

const ChatInput = ({ userInput, handleInputChange, handleSubmit, isLoading }) => {
  return (
    <form id="chat-form" onSubmit={handleSubmit}>
      <input
        type="text"
        id="user-input"
        name="user_input"
        placeholder="Type your message..."
        value={userInput}
        onChange={handleInputChange}
        required
        maxLength={1000}
        disabled={isLoading}
      />
      <button type="submit" disabled={isLoading}>
        {isLoading ? 'Sending...' : 'Send'}
      </button>
    </form>
  );
};

export default ChatInput;
